const ConfigurationCardTypes = {
  SANDBOX: "sandbox",
  PRODUCTION: "production"
};

ConfigurationCardTypes.ALL = Object.values(ConfigurationCardTypes);

export default ConfigurationCardTypes;
